<template>
<v-layout v-resize="onResize" column style="padding-top:56px">
  <v-data-table flat
    :headers="headers"
    :items="tickets"
    class="elevation-2"
    :loading="isLoading"
    :total-items="totalResources"
    :rows-per-page-items="limitOptions"
    :pagination.sync="pagination"
    :hide-headers="isMobile" :class="{mobile: isMobile}"
  >
    <template slot="items" slot-scope="props">
    <tr v-if="!isMobile">
      <td class="text-xs-left">#{{ props.item.id }}</td>
      <td class="text-xs-left">
      <v-chip v-if="props.item.new_admin_comment" color="green" text-color="white">
          Nova mensagem
    </v-chip>
    </td>
      <td class="text-xs-left">{{ props.item.subject }}</td>
      <td class="text-xs-left">{{ props.item.sale_code }}</td>
      <td class="text-xs-left">
      <v-chip :class="setChipColor(props.item.status)">{{ $t(`status.${props.item.status}`) }}</v-chip>
      </td>
      <td class="text-xs-left">{{ formatDate(props.item.created_at) }}</td>
      <td class="text-xs-center">
        <router-link :to="{ name: 'ticket', params: { id: props.item.id }}">Visualizar</router-link>
      </td>
    </tr>
    <tr v-else>
      <td>
        <ul class="flex-content">
          <li class="flex-item" data-label="#">{{ props.item.id }}</li>
          <li class="flex-item" data-label="">
            <v-chip v-if="props.item.new_admin_comment" color="green" text-color="white">
              Nova mensagem
            </v-chip>
          </li>
          <li class="flex-item" data-label="Assunto">{{ props.item.subject }}</li>
          <li class="flex-item" data-label="Código da Venda">{{ props.item.sale_code }}</li>
          <li class="flex-item" data-label="Status">
            <v-chip :class="setChipColor(props.item.status)" small text-color="white">{{ $t(`status.${props.item.status}`) }}</v-chip>
          </li>
          <li class="flex-item" data-label="Criado em">{{ $d(new Date(props.item.created_at), 'short') }}</li>
          <li class="flex-item" data-label="Visualizar">
          <router-link :to="{ name: 'ticket', params: { id: props.item.id }}">Visualizar</router-link>
          </li>
        </ul>
      </td>
    </tr>
    
    </template>
  </v-data-table>
  </v-layout>
</template>
<script>

import { mapGetters, mapActions } from 'vuex';
import { changed } from '@/helpers/layout';
import moment from 'moment';

export default {
  mounted() {
    this.$store.dispatch('tickets/load', this.filters);
  },
  computed: {
    ...mapGetters({
      tickets: 'tickets/list',
      totalResources: 'tickets/totalResources',
      limitOptions: 'tickets/limitOptions',
      currentPage: 'tickets/currentPage',
      filters: 'tickets/filter',
      isLoading: 'tickets/loadingData',
    }),
    pages() {
      return 0;
    },
  },
  watch: {
    pagination: function pagination(newPagination, oldPagination) {
      if (changed(newPagination.rowsPerPage, oldPagination.rowsPerPage)) {
        this.setLimit(newPagination.rowsPerPage);
        this.$store.dispatch('tickets/load', this.filters);
      }
      if (changed(newPagination.page, oldPagination.page)) {
        this.setCurrentPage(newPagination.page);
        this.$store.dispatch('tickets/load', this.filters);
      }
    },
  },
  methods: {
    ...mapActions({
      setCurrentPage: 'tickets/setCurrentPage',
      setLimit: 'tickets/setLimit',

    }),
    setChipColor(status) {
      return `ticket ${status.toLowerCase()}`;
    },
    formatDate(date) {
      if (!date) return '';
      return moment(date).format('DD/MM/YYYY HH:mm');
    },
    onResize() {
      if (window.innerWidth < 769)
        this.isMobile = true;
      else
        this.isMobile = false;
    },
  },
  data() {
    return {
      items: [],
      count: 0,
      pagination: {},
      isMobile: false,
      headers: [
        { text: this.$t('phrases.ticketId'), value: 'ticketId' },
        { text: this.$t(''), value: '' },
        { text: this.$t('words.subject'), value: 'subject' },
        { text: this.$t('phrases.saleCode'), value: 'saleCode' },
        { text: this.$t('words.statusCamelCase'), value: 'statusCamelCase' },
        { text: this.$t('phrases.createdAt'), value: 'createdAt' },
        { text: '', value: '' },
      ],
    };
  },
};
</script>
<style>
.mobile {
      color: #333;
    }

    @media screen and (max-width: 768px) {
      .mobile table.v-table tr {
        max-width: 100%;
        position: relative;
        display: block;
      }

      .mobile table.v-table tr:nth-child(odd) {
        border-left: 6px solid #b2b2b8;
      }

      .mobile table.v-table tr:nth-child(even) {
        border-left: 6px solid cyan;
      }

      .mobile table.v-table tr td {
        display: flex;
        width: 100%;
        border-bottom: 1px solid #636366;
        height: auto;
        padding: 10px;
      }

      .mobile table.v-table tr td ul li:before {
        content: attr(data-label);
        padding-right: .5em;
        text-align: left;
        display: block;
        color: #999;

      }
      .v-datatable__actions__select
      {
        width: 50%;
        margin: 0px;
        justify-content: flex-start;
      }
      .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
        background: transparent;
      }

    }
    .flex-content {
      padding: 0;
      margin: 0;
      list-style: none;
      display: flex;
      flex-wrap: wrap;
      width: 100%;
    }

    .flex-item {
      padding: 5px;
      width: 50%;
      height: 40px;
      font-weight: bold;
      margin-top: 10px;
    }
  .v-chip.ticket.opened     { background-color: #3dc444 !important; }
  .v-chip.ticket.pending    { background-color: rgb(233, 130, 45) !important; }
  .v-chip.ticket.closed     { background-color: rgb(184, 184, 184) !important; }
</style>
